import { Menu, Button, Modal, ActionIcon, Tooltip } from '@mantine/core'
import { notifications } from '@mantine/notifications'

// Icon
import { IconRefresh, IconDotsVertical } from '@tabler/icons-react'

// User
import useMe from '@/hooks/useMe'

import ActivityLog from '@/components/ui/ActivityLog'

// Hooks
import useUserLocation from '@/hooks/useUserLocation'
import { useAxiosApi } from '@/hooks/useAxiosApi'

// UI
import Badge from '../ui/Badge'

// React
import { useState } from 'react'

export default function ComponentHeaderRightSection({
    component,
    editChildrenHandlers,
    editComponentHandlers,
    onRefresh,
    archiveComponent,
    unarchiveComponent,
    deleteComponent,
}) {
    // User
    const { isAdmin } = useMe()

    // Printer
    const { userPrinters } = useUserLocation()
    const { requestPost } = useAxiosApi()
    const productLabelPrinter = userPrinters.product_label

    const printLabel = async () => {
        try {
            await requestPost(`/components/${component.id}/print-label`, {
                printnode_ids: productLabelPrinter.printnode_ids,
            })
            notifications.show({
                title: 'Impression lancée',
                message: `Envoyé sur ${productLabelPrinter.name}`,
                color: 'green',
            })
        } catch (e) {
            notifications.show({
                title: 'Erreur d\'impression',
                message: e.response?.data?.error_message || 'Erreur inconnue',
                color: 'red',
            })
        }
    }

    // Modal state
    const [deletedModalOpened, setDeletedModalOpened] = useState(false)

    return (
        <div className="flex items-end gap-2">
            {component?.id && (
                <ActivityLog subjectType="components" subjectId={component.id} />
            )}

            <Tooltip label="Rafraichir les données">
                <ActionIcon variant="default" size={36} onClick={onRefresh}>
                    <IconRefresh size={15} />
                </ActionIcon>
            </Tooltip>

            {component?.is_archived && (
                <Badge color="gray" size="md">
                    Archivé
                </Badge>
            )}

            {isAdmin && (
                <Menu shadow="md" width={200} position="bottom-end">
                    <Menu.Target>
                        <ActionIcon variant="default" size={36}>
                            <IconDotsVertical size={15} />
                        </ActionIcon>
                    </Menu.Target>

                    <Menu.Dropdown>
                        {productLabelPrinter && (
                            <Menu.Item onClick={printLabel}>
                                Imprimer l'étiquette
                            </Menu.Item>
                        )}

                        <Menu.Item onClick={editComponentHandlers.open}>
                            Modifier le composant
                        </Menu.Item>

                        <Menu.Item onClick={editChildrenHandlers.open}>
                            Modifier les éléments
                        </Menu.Item>

                        {!component?.is_archived && (
                            <Menu.Item onClick={archiveComponent}>
                                Archiver
                            </Menu.Item>
                        )}

                        {component?.is_archived && (
                            <Menu.Item onClick={unarchiveComponent}>
                                Désarchiver
                            </Menu.Item>
                        )}

                        <Menu.Item
                            color="red"
                            onClick={() => setDeletedModalOpened(true)}
                        >
                            Supprimer
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu>
            )}

            <Modal
                opened={deletedModalOpened}
                onClose={() => setDeletedModalOpened(false)}
                title="Confirmer la suppression du composant"
            >
                <div className="flex flex-col gap-3">
                    <Button color="red" onClick={deleteComponent}>
                        Supprimer le composant
                    </Button>
                </div>
            </Modal>
        </div>
    )
}
